// extracted by mini-css-extract-plugin
export default {"wrapper":"technology_wrapper__zePBL","title":"technology_title__MatL7","pannel":"technology_pannel__lmrkm","content":"technology_content__jl+IC"};